<template>
  <div class="db relative center pt5">
    <div class="db relative center ph3 ph0-ns mv0">
      <social-icons></social-icons>
    </div>
    <div class="db relative center mt3 pv3 footer container-fluid-full-width bb-red">
      <div class="flex center mw6 pv4 relative flex-row items-center justify-around">
        <router-link class="db center f6 f5-ns tc ttu is-bebas no-underline pointer is-white" to="/contact/">
          Contact
        </router-link>
        <router-link class="db center f6 f5-ns tc ttu is-bebas no-underline pointer is-white" to="/terms-of-use/">
          Terms of Use
        </router-link>
        <router-link class="db center f6 f5-ns tc ttu is-bebas no-underline pointer is-white" to="/privacy-policy/">
          Privacy Policy
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
//import SocialIcons from './social-icons.vue';
export default {
  //template: '#app-footer-template',
  components: {
   //'social-icons': SocialIcons,
  },
  props: {
    //
  },
  data () {
    return {
      newItem: 'Data binding',
      newDynamic: [],
    }
  },
  mounted () {
    //bus.$on('openVidModal', (data) => {
      //this.ytId = data;
      //this.$modal.show('video', { ytId: this.ytId });
    //})
  },
  computed: {
    //
  },
  methods: {
    //
  }
}
</script>